// extracted by mini-css-extract-plugin
module.exports = {"editbtn":"EditButton_editbtn__2049h"};